export default function RescoreIco() {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2901_188348)">
        <path
          d="M12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.7533 48.5 2.5 44.2467 2.5 39V11C2.5 5.7533 6.75329 1.5 12 1.5Z"
          stroke="#EAECF0"
          shape-rendering="crispEdges"
        />
        <path
          d="M33.0869 14.9678C33.2732 14.931 33.4663 14.9505 33.6416 15.0234L33.7676 15.0879C33.8887 15.1609 33.9924 15.2602 34.0713 15.3789L34.1416 15.502C34.2015 15.6297 34.2319 15.7699 34.2314 15.9121V19.5479C34.2314 19.7705 34.1546 19.9856 34.0146 20.1562L33.9512 20.2266C33.7713 20.4064 33.5268 20.5068 33.2725 20.5068H29.6367C29.4944 20.5068 29.3542 20.4754 29.2266 20.415L29.1035 20.3457C28.9852 20.2666 28.887 20.162 28.8145 20.041L28.75 19.915C28.6775 19.7399 28.6594 19.5472 28.6963 19.3613L28.7334 19.2246C28.781 19.0919 28.8575 18.9707 28.958 18.8701L29.9346 17.8926C28.8088 17.264 27.5496 16.9147 26.2627 16.875L26 16.8711C24.4921 16.8711 23.0159 17.2905 21.7354 18.0791L21.4824 18.2412C20.2287 19.0787 19.234 20.2474 18.6074 21.6143L18.4873 21.8906C17.8719 23.3762 17.7107 25.0108 18.0244 26.5879L18.0889 26.8818C18.4366 28.3447 19.1838 29.6849 20.25 30.751L20.4668 30.96C21.5687 31.9829 22.9345 32.6814 24.4131 32.9756L24.71 33.0293C26.1948 33.2678 27.7193 33.0906 29.1123 32.5137C30.5981 31.8983 31.8682 30.8555 32.7617 29.5186L32.9238 29.2656C33.7125 27.9854 34.1318 26.5095 34.1318 25.002C34.1318 24.7476 34.2332 24.5031 34.4131 24.3232L34.4834 24.2598C34.654 24.1201 34.8684 24.043 35.0908 24.043C35.3452 24.043 35.5897 24.1434 35.7695 24.3232L35.833 24.3936C35.9729 24.5642 36.0498 24.7793 36.0498 25.002C36.0498 26.9891 35.4606 28.9317 34.3564 30.584C33.3212 32.1331 31.877 33.3625 30.1875 34.1367L29.8457 34.2852C28.124 34.9981 26.2404 35.2177 24.4053 34.9229L24.0391 34.8564C22.2115 34.4929 20.5231 33.6297 19.1611 32.3652L18.8936 32.1064C17.5759 30.789 16.6524 29.1331 16.2227 27.3252L16.1436 26.9619C15.7558 25.0128 15.9542 22.9923 16.7148 21.1562L16.8643 20.8154C17.6386 19.1261 18.8676 17.6816 20.417 16.6465L20.7295 16.4463C22.3121 15.4716 24.1364 14.9531 26 14.9531L26.3564 14.959C28.1215 15.0163 29.8412 15.5425 31.3389 16.4854L32.5947 15.2305L32.7021 15.1387C32.8157 15.0545 32.9471 14.9954 33.0869 14.9678Z"
          fill="#344054"
          stroke="#344054"
          stroke-width="0.1"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2901_188348"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2901_188348"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2901_188348"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
